import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";

export default class FormDatosCiviles extends Component {
  constructor(props) {
    super(props);
    this.setInformacionOrganismo = this.setInformacionOrganismo.bind(this);
  }

  async setInformacionOrganismo(event) {
    event.preventDefault();
    let $this = $(this);
    //Formdata coge todo los elementos del formulario
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/provincias/" + $this[0].props.DatosProvincia.id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito los asigna al estado del componente monja detalle
    await $.ajax(settings)
      .done(async function (response) {
        response = JSON.parse(response);
        $this[0].props.setInformacionOrganismo(response);
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
      })

      .fail($this[0].props.ErrorHandling);
  }

  render() {
    return (
      <Form className=" p-4" onSubmit={this.setInformacionOrganismo} id="MyForm" autoComplete="off">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Número de Registro Ministerial *</Form.Label>
          <Form.Control required type="text" name="ministerialRegisterNumber" autoComplete="nope" defaultValue={this.props.DatosProvincia.ministerialRegisterNumber} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Número de Identificación Fiscal *</Form.Label>
          <Form.Control required type="text" name="fiscalNumber" autoComplete="nope" defaultValue={this.props.DatosProvincia.fiscalNumber} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Personalidad Jurídica *</Form.Label>
          <Form.Control required autoComplete="nope" as="select" name="legalForm" defaultValue={this.props.DatosProvincia.legalForm}>
            <option>Congregación religiosa</option>
            <option>Asociación civil</option>
            <option>Asociación sin fines de lucro</option>
            <option>Sin retenciones</option>
          </Form.Control>
        </Form.Group>
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Datos Civiles"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
